/*
 * Copyright (c) CIRROM 2025.
 */

import { API } from "./api";

export interface Contact {
  id: number;
  first_name: string;
  last_name: string;
  company: string;
  crm_contact_id: string;
}

export const searchForContacts = async (
  integratedSystemId: number,
  searchTerm: string
): Promise<Contact[]> => {
  const response = await API.get("/search-for-contacts", {
    params: {
      integrated_system_id: integratedSystemId,
      search_term: searchTerm,
    },
  });
  return response.data;
};
